
<table class="table" style="background-color:white;">
  <thead>
    <tr>
      <th style="background-color:#0f2b46;color:white;" colspan="2"> Recent Notifications     </th>
      <th style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let d of dataList">
      <td style="width:15%">
        <img style="height:69px;width:96px; border-radius:49%" src="{{d.fileupload}}" />
      </td>
      <td style="width:65%">
        <h3>{{d.title}} </h3>
        <h5>{{d.messagebody}}</h5>
      </td>
      <td style="width:20%">{{d.chkhrmin}}</td>

    <tr>
  </tbody>

</table>

